import { unsubscribeSubscriptions } from '../../../../modules/shared/services/util.service';
import { SubscriptionList } from '../../../..//modules/shared/models/asp.types';
import { MatDialog } from '@angular/material/dialog';
import { Predicate } from '@ngrx/entity';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { OpCodeState } from './../../../store/opcode/opcode.reducer';
import { Store } from '@ngrx/store';
import { Component, OnInit, OnDestroy } from '@angular/core';
import * as OpCodeActions from './../../../store/opcode/opcode.actions';
import * as fromSelector from '../../../store/opcode/opcode.selectors';
import { IServiceOpcode, OnlineOpcodeSortBy, SortOrder } from '@signal/asp-data-commons';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-txm-opcode-list',
  templateUrl: './txm-opcode-list.component.html',
  styleUrls: ['./txm-opcode-list.component.scss']
})
export class TxmOpcodeListComponent implements OnInit, OnDestroy {
  opCodeListForm: UntypedFormGroup;

  loading = false;
  isSelected: string = null;
  index = -1;

  onlineOpCodesCount: number = 0;

  aspTxmOnlineOpCodes: IServiceOpcode[] = [];
  aspOnlineOpCodes: IServiceOpcode[] = [];
  txmRecommendedOnlineOpCodes: IServiceOpcode[] = [];
  txmRegularOnlineOpCodes: IServiceOpcode[] = [];
  onlineOpCodes: IServiceOpcode[] = [];
  dmsOpCodes: IServiceOpcode[] = [];
  txmOpcodes: IServiceOpcode[] = [];

  selectedOpcodeListFromOnline: IServiceOpcode[] = [];
  selectedAspOpcodeListFromOnline: IServiceOpcode[] = [];
  selectedDmsOpcodeListFromOnline: IServiceOpcode[] = [];
  selectedOpcodeListFromTxm: IServiceOpcode[] = [];
  selectedOpcodeListFromTxmAsp: IServiceOpcode[] = [];
  selectedOpcodeListFromTxmRecommended: IServiceOpcode[] = [];
  selectedOpcodeListFromTxmOther: IServiceOpcode[] = [];
  private subs: SubscriptionList = {};
  isEnglishTranslation:boolean = true;


  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly opCodeStore: Store<OpCodeState>,
    public dialog: MatDialog,
    private readonly translate: TranslateService) {
  }


  ngOnInit(): void {
    this.isEnglishTranslation = this.translate.currentLang?.includes('es') ? false : true;
    this.initializeForm();

    this.loadOnlineOpCodeDetails();

  }



  loadOnlineOpCodeDetails() {

    this.opCodeStore.dispatch(new OpCodeActions.LoadOnlineOpCodes({
      sort: this.onlineOpCodesForm.get('sortBy').value,
      order: this.onlineOpCodesForm.get('sortOrder').value,
      limit: '500',
      query: this.onlineOpCodesForm.get('searchQuery').value
    }));

    const onlineServiceOpCodePredicate: Predicate<IServiceOpcode> =
    (t: IServiceOpcode) => t.isVisible;

    const dmsServiceOpCodePredicate: Predicate<IServiceOpcode> =
      (t: IServiceOpcode) => t.isVisible && !t.isAspCreated;
    
    const aspServiceOpCodePredicate: Predicate<IServiceOpcode> =
      (t: IServiceOpcode) => t.isVisible && t.isAspCreated;

    const txmServiceOpCodePredicate: Predicate<IServiceOpcode> =
      (t: IServiceOpcode) => t.isVisible && t.isTXM;

    const txmAspServiceOpCodePredicate: Predicate<IServiceOpcode> =
      (t: IServiceOpcode) => t.isVisible  && t.isTXM && t.isAspCreated ;
      
    const txmRecommendedServiceOpCodePredicate: Predicate<IServiceOpcode> =
      (t: IServiceOpcode) => t.isVisible &&  t.isTXM && t.recommended?.isRecommended;

    const txmRegularServiceOpCodePredicate: Predicate<IServiceOpcode> =
      (t: IServiceOpcode) => t.isVisible &&  t.isTXM && !t.recommended?.isRecommended;

    this.subs.selectonlineopcodelist = this.opCodeStore.select(fromSelector.selectOnlineOpCodesList).subscribe(t => {
      this.onlineOpCodesCount = t.length;
    });
    this.subs.onlineopcodes = this.opCodeStore.select(fromSelector.selectOnlineOpCodesByPredicate, { predicate: onlineServiceOpCodePredicate }).subscribe(t => {
      this.onlineOpCodes = t;
      this.sortOpcodes();
    });
    this.subs.asponlineopcodes = this.opCodeStore.select(fromSelector.selectOnlineOpCodesByPredicate, { predicate: aspServiceOpCodePredicate }).subscribe(t => {
      this.aspOnlineOpCodes = t;
    });
    this.subs.dmsonlineopcodes = this.opCodeStore.select(fromSelector.selectOnlineOpCodesByPredicate, { predicate: dmsServiceOpCodePredicate }).subscribe(t => {
      this.dmsOpCodes = t;
    });
    this.subs.txmopcodes = this.opCodeStore.select(fromSelector.selectOnlineOpCodesByPredicate, { predicate: txmServiceOpCodePredicate }).subscribe(t => {
      this.txmOpcodes = t;
    });

    this.subs.txmAsponlineopcodes = this.opCodeStore.select(fromSelector.selectOnlineOpCodesByPredicate, { predicate: txmAspServiceOpCodePredicate }).subscribe(t => {
      this.aspTxmOnlineOpCodes = t;
    });
   
    this.subs.reconlineservicessortorder = this.opCodeStore.select(fromSelector.selectOnlineOpCodesByPredicate, { predicate: txmRecommendedServiceOpCodePredicate }).subscribe(t => {
      this.txmRecommendedOnlineOpCodes = t;
    });

    this.subs.regularonlineservicessortorder = this.opCodeStore.select(fromSelector.selectOnlineOpCodesByPredicate, { predicate: txmRegularServiceOpCodePredicate }).subscribe(t => {
      this.txmRegularOnlineOpCodes = t;
    });

  }
  propComparator(sortValues: IServiceOpcode[]) {
    return sortValues.sort((a: IServiceOpcode, b: IServiceOpcode) => {
      return this.sortOrder === SortOrder.ASC ? a.displayName.localeCompare(b.displayName)  :
      b.displayName.localeCompare(a.displayName);
    })
  }
  sortByPrice(sortValues) {
    return sortValues.sort((a: IServiceOpcode, b: IServiceOpcode) => {
      return this.sortOrder === SortOrder.ASC ? a?.pricing?.dms - b?.pricing?.dms :
      b?.pricing?.dms - a?.pricing?.dms;
    })
  }

  updateMiscOpCode(){};

  initializeForm() {
    this.opCodeListForm = this.fb.group({
      onlineOpCodesForm: this.fb.group({
        searchQuery: [''],
        sortBy: [OnlineOpcodeSortBy.ALPHA],
        sortOrder: [SortOrder.ASC]
      }),
      txmOpCodesForm: this.fb.group({
        showOpCodes: ['all'],
        sortBy: [OnlineOpcodeSortBy.ALPHA]
      })
    });

    this.subs.searchQueryfromform = this.onlineOpCodesForm.get('searchQuery').valueChanges.subscribe((t: string) => {
      if (t.trim().length > 3 || t.length === 0){
        this.loadOnlineOpCodeDetails();
      }
    });

    this.subs.allsortbyfromform = this.onlineOpCodesForm.get('sortBy').valueChanges.subscribe(t => {
      if (t === 'alpha') {
        this.onlineOpCodes = this.propComparator(this.onlineOpCodes)
      }
      else if( t === 'price'){
        this.onlineOpCodes = this.sortByPrice(this.onlineOpCodes)
      }

    });
  }

  get txmOpCodesForm() {
    return this.opCodeListForm.get('txmOpCodesForm') as UntypedFormGroup;
  }

  get onlineOpCodesForm() {
    return this.opCodeListForm.get('onlineOpCodesForm') as UntypedFormGroup;
  }

  get onlineOpcodesSortBy(){
    return this.onlineOpCodesForm.get('sortBy').value;
  }

  get sortOrder() {
    return this.onlineOpCodesForm.get('sortOrder').value;
  }

  get txmShowOpCodes() {
    return this.txmOpCodesForm.get('showOpCodes').value;
  }

  onSortOrderChange() {
    this.onlineOpCodesForm.get('sortOrder').setValue(this.onlineOpCodesForm.get('sortOrder').value === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC)
    this.sortOpcodes();

  }
  sortOpcodes(){
    this.onlineOpCodes = this.onlineOpcodesSortBy === 'alpha' ? this.propComparator(this.onlineOpCodes) : 
    this.sortByPrice(this.onlineOpCodes);
  }


  itemsRemoved(ev, list) {
  }

  itemsAdded(ev: IServiceOpcode[], list) {
  }

  itemsUpdated(ev, list) {
  }

  selectionChanged(ev, list) {
    this.selectedOpcodeListFromOnline = list === 1 ? ev : this.selectedOpcodeListFromOnline;
    this.selectedAspOpcodeListFromOnline = list === 2 ? ev : this.selectedAspOpcodeListFromOnline;
    this.selectedDmsOpcodeListFromOnline = list === 3 ? ev : this.selectedDmsOpcodeListFromOnline;
    this.selectedOpcodeListFromTxm = list === 4 ? ev : this.selectedOpcodeListFromTxm;
    this.selectedOpcodeListFromTxmAsp = list === 5 ? ev : this.selectedOpcodeListFromTxmAsp;
    this.selectedOpcodeListFromTxmRecommended = list === 6 ? ev : this.selectedOpcodeListFromTxmRecommended;
    this.selectedOpcodeListFromTxmOther = list === 7 ? ev : this.selectedOpcodeListFromTxmOther;
  }


  updateServiceStatus(status: boolean) {
    if ((this.selectedOpcodeListFromOnline.length > 0 || this.selectedAspOpcodeListFromOnline.length > 0 
      || this.selectedDmsOpcodeListFromOnline.length > 0 ) === status ||
      (this.selectedOpcodeListFromTxm.length > 0 || this.selectedOpcodeListFromTxmRecommended.length > 0
        || this.selectedOpcodeListFromTxmOther.length > 0 || this.selectedOpcodeListFromTxmAsp.length>0) === status) {
      for (const opcode of (status ? [...this.selectedOpcodeListFromOnline, ...this.selectedAspOpcodeListFromOnline, 
      ...this.selectedDmsOpcodeListFromOnline ]: [...this.selectedOpcodeListFromTxm,...this.selectedOpcodeListFromTxmAsp,
      ...this.selectedOpcodeListFromTxmRecommended, ...this.selectedOpcodeListFromTxmOther])) {
        if (status !== opcode.isTXM){
          this.opCodeStore.dispatch(new OpCodeActions.UpdateOpCode({ opcode: { ...opcode, isTXM: status } }));
        }
      }
    }
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
  }
  clearAspSelected(event){
    if(event){
      this.isSelected = null;
      this.index = -1;
    }
  }
}

